import { Switch, Route } from 'react-router-dom'
import MainLayout from '../layouts/main-layout'

const LayoutsRoute = props => {
    return (
        <Switch>
            <Route path="/" component={MainLayout} />
        </Switch>
    )
}

export default LayoutsRoute